import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import freedomTheme from 'web_component_library/theme/freedom';
import stringInterpolation from 'web_component_library/utils/stringInterpolation';
import Button from 'web_component_library/button';
import { PauseIcon, PlayIcon } from './icons';

const { colors } = freedomTheme;

export const NavBar = ({
  children,
  scrollTo,
  handlePlayPause,
  isRunning,
  selectSlideText,
  playText,
  pauseText,
  selectedIndex,
  viewDuration = null,
  time = null,
  showProgressBar,
}) => {
  if (React.Children.toArray(children).length <= 1) {
    return null;
  }
  return (
    <Box
      data-testid="navbarCarrousel"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '36px',
        padding: '12px 16px',
        gap: '14px',
        backgroundColor: colors.white,
        borderRadius: '100px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Button
        variant="none"
        aria-label={isRunning ? pauseText : playText}
        css={{
          width: '1rem',
          height: '1rem',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          backgroundColor: colors.white,
          color: colors.accessibleOrange,
          padding: 0,
        }}
        onClick={handlePlayPause}
      >
        {isRunning ? (
          <PauseIcon
            style={{ width: 'inherit', height: 'inherit' }}
            aria-hidden="true"
          />
        ) : (
          <PlayIcon
            style={{ width: 'inherit', height: 'inherit' }}
            aria-hidden="true"
          />
        )}
      </Button>

      {React.Children.toArray(children).map((child, index) => (
        <Button
          // eslint-disable-next-line react/no-array-index-key
          key={`${child?.props?.entryTitle}-${index}`}
          variant="none"
          aria-label={stringInterpolation(selectSlideText, index + 1)}
          aria-pressed={index === selectedIndex}
          onClick={() => scrollTo(index)}
          borderRadius="0.5rem"
          sx={{
            width: index === selectedIndex ? '3rem' : '1rem',
            height: '1rem',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            backgroundColor:
              index === selectedIndex && !showProgressBar
                ? colors.accessibleOrange
                : colors.grey,
            transition: 'all 300ms',
            position: 'relative',
            overflow: 'hidden',
            '&:before': {
              ...(index === selectedIndex && showProgressBar
                ? {
                    content: "' '",
                    width: `${(time / (viewDuration * 1000)) * 100}%`,
                    height: '100%',
                    background: colors.accessibleOrange,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    transition: 'all 0ms',
                  }
                : {}),
            },
          }}
        />
      ))}
    </Box>
  );
};
NavBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  scrollTo: PropTypes.func.isRequired,
  handlePlayPause: PropTypes.func.isRequired,
  isRunning: PropTypes.bool.isRequired,
  selectSlideText: PropTypes.string.isRequired,
  playText: PropTypes.string.isRequired,
  pauseText: PropTypes.string.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  viewDuration: PropTypes.number,
  time: PropTypes.number,
  showProgressBar: PropTypes.bool.isRequired,
};
